import styled from 'styled-components';
import { FOCUS_OUTLINE } from '@optimus-web/common';

export const Clickable = styled.button`
    margin: 0;
    padding: 0;
    background-color: transparent;
    border: none;
    cursor: pointer;
    text-align: inherit;
    ${FOCUS_OUTLINE};
`;
